<template>
    <div class="key-data-risk-control-info">
        <div class="title-container">
            <span class="sub-title">企业风控信息</span>
            <i :class="contentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapse"></i>
        </div>
        <div class="content" v-if="contentVisible">
            <div class="rc-form-block">
                <el-row :gutter="10">
                    <el-col :span="6">
                        <div class="rc-label">风险评估：</div>
                        <div class="rc-value">{{ dictData.SRM_RISK_ESTIMATE[headInfo.riskEstimate] || DEF_VAL }}</div>
                    </el-col>
                    <el-col :span="18">
                        <div class="rc-label">企业三要素验证：三码(注册号/组织机构代码/统一社会信用代码)：</div>
                        <div class="rc-value">{{ FLOW_STATUS[threeElement.flowStatus] || DEF_VAL }}</div>
                    </el-col>
                </el-row>
            </div>
            <div class="rc-table-block">
                <div class="rc-title"><div>被执行人</div></div>
                <el-table
                    :data="zhiXingInfo"
                >
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="caseCode"
                        label="案件名称"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="partyCardNum"
                        label="身份证号/组织机构代码"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="pname"
                        label="被执行人名称"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="execCourtName"
                        label="执行法院"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="caseCreateTime"
                        label="创建时间"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="execMoney"
                        label="执行标的(元)"
                    ></el-table-column>
                </el-table>
            </div>
            <div class="rc-table-block">
                <div class="rc-title"><div>限制消费令</div></div>
                <el-table
                    :data="consumption"
                >
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="xname"
                        label="限制消费者名称"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="applicant"
                        label="申请人信息"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="caseCreateTime"
                        label="立案时间"
                    ></el-table-column>
                </el-table>
            </div>
            <div class="rc-table-block">
                <div class="rc-title"><div>法律诉讼</div></div>
                <el-table
                    :data="lawSuitInfo"
                >
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="title"
                        label="案件名称"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="caseMoney"
                        label="案件金额"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="court"
                        label="审理法院"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="caseType"
                        label="案件类型"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="judgeTime"
                        label="裁判日期"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="casePersons"
                        label="涉案方"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="type"
                        label="类型"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="role"
                        label="案件身份"
                    ></el-table-column>
                </el-table>
            </div>
            <div class="rc-table-block">
                <div class="rc-title"><div>失信人</div></div>
                <el-table
                    :data="dishonestInfo"
                >
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="businessentity"
                        label="法人/负责人姓名"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="type"
                        label="失信人姓名"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="iname"
                        label="失信人名称"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="disrupttypename"
                        label="失信被执行人行为具体情形"
                    ></el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        prop="regdate"
                        label="立案时间"
                    ></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
import dayjs from 'dayjs'
import { dictWithUrl } from '@/components/lots/api'
import { searchEyeInfo } from '../../../../../../api/riskControl.js'

const FLOW_STATUS = {
    INIT: '认证中',
    FINISH: '认证完成',
    WRONG: '信息有误',
}

const DEF_VAL = '---'

export default {
    components: { },
    props: {
        supplierParams: {
            type: Object,
            default: () => {
                return {
                    id: '',
                    businessType: '',
                    supplierCode: '',
                    propertyNature: '',
                }
            }
        }
    },
    data() {
        return {
            contentVisible: false,
            dictData: {},
            formData: {},
            // 风控信息相关数据
            headInfo: {
                riskEstimate: DEF_VAL,
            },
            threeElement: {
                flowStatus: DEF_VAL,
            },
            zhiXingInfo: [],
            consumption: [],
            lawSuitInfo: [],
            dishonestInfo: [],
            FLOW_STATUS,
            DEF_VAL,
            dictData: {
                SRM_RISK_ESTIMATE: {}, // 风险评估
            },
        };
    },
    methods: {
        loadData() {
            searchEyeInfo({ supplierCode: this.supplierParams.supplierCode }).then(res => {
                if (res && +res.code === 0) {
                    this.setData(res.data);
                }
            }).catch(err => {})
        },
        handleCollapse() {
            this.contentVisible = !this.contentVisible
        },
        setData(data) {
            const dictKeys = Object.keys(this.dictData);
            dictWithUrl(dictKeys.join(',')).then(res => {
                if (res && +res.code === 0) {
                    this.dictData = res.data;
                    this.headInfo = this.formatData(data, this.headInfo);
                    this.threeElement = this.formatData(data.threeElement, this.threeElement);
                    this.zhiXingInfo = this.formatDataList(data.zhiXingInfo, this.zhiXingInfo).map(item => {
                        if (item.caseCreateTime && item.caseCreateTime !== DEF_VAL) {
                            item.caseCreateTime = dayjs(Number(item.caseCreateTime)).format('YYYY-MM-DD')
                        }
                        return item;
                    });
                    this.consumption = this.formatDataList(data.consumption).map(item => {
                        if (item.caseCreateTime && item.caseCreateTime !== DEF_VAL) {
                            item.caseCreateTime = dayjs(Number(item.caseCreateTime)).format('YYYY-MM-DD')
                        }
                        return item;
                    });
                    this.lawSuitInfo = this.formatDataList(data.lawSuitInfo);
                    this.dishonestInfo = this.formatDataList(data.dishonestInfo).map(item => {
                        if (item.regdate && item.regdate !== DEF_VAL) {
                            item.regdate = dayjs(Number(item.regdate)).format('YYYY-MM-DD')
                        }
                        return item;
                    });
                }
            })
        },
        formatData(data, form) {
            const tempData = {};
            Object.keys(form).forEach(key => {
                tempData[key] = ['', null, undefined].includes(data[key]) ? DEF_VAL : data[key];
                if (key === 'flowStatus') {
                    tempData[key] = String(tempData[key]).toUpperCase();
                }
                if (key === 'type') {
                    tempData[key] = tempData[key] === '1' ? '人员' : (tempData[key] === '2' ? '公司': DEF_VAL)
                }
            });
            return tempData;
        },
        formatDataList(data) {
            let tempData = [];
            if (data.length) {
                const form = data[0];
                tempData = data.map(item => {
                    return this.formatData(item, form);
                });
            }
            return tempData;
        },
    },
    mounted() {
        this.loadData()
    },
};
</script>
<style lang="less">
.key-data-risk-control-info {
    font-size: 14px;
    color: #000;

    .sub-title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .title-container {
        margin-bottom: 5px;

        i {
            float: right;
            padding-right: 10px;
            font-size: 24px;
            cursor: pointer;
        }
    }

    .content {
        font-size: 13px;

        .el-col {
            display: flex;
            margin-bottom: 10px;
        }

        .rc-form-block {
            margin-bottom: 10px;
        }

        .rc-table-block {
            margin-bottom: 20px;
        }

        .rc-label {
            margin-right: 10px;
            color: #22272799;
        }

        .rc-title {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            font-size: 14px;

            &::before {
                width: 3px;
                height: 25px;
                background: #00A9AC;
                content: '';
            }

            & > div {
                padding: 3px 0 3px 6px;
                background-image: linear-gradient(to right, #E8F7F8, transparent);
            }
        }

        .el-table {
            border-left: 1px solid #ebeef5;
            border-right: 1px solid #ebeef5;
        }

        .el-table th {
            background-color: #F5F7FA;
        }
    }

    
}
</style>